import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { observer } from "mobx-react";
import Compressor from "compressorjs";
import { Form, Spinner } from "react-bootstrap";
import async from "async";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faSquare } from "@fortawesome/free-regular-svg-icons";
import { faCircleCheck, faSquareCheck } from "@fortawesome/free-solid-svg-icons";

import { uploadImage } from "../../utils/upload";

const AnswerBlock = ({
  data,
  type,
  blur,
  isLast,
  inputChange,
  removeClick,
  correctChange,
  addClick,
  imageChange,
}) => {
  const { content, is_correct } = data;
  const imageRef = useRef();
  const [imageUrl, setImageUrl] = useState();
  const [thumbnailUrl, setThumbnailUrl] = useState();
  // const [loading, setLoading] = useState();

  useEffect(() => {
    if (data) {
      setImageUrl(data.image_url);
      setThumbnailUrl(data.image_url);
    }
  }, [data]);

  const fileChangeHandler = (e) => {
    const file = e.target.files[0];

    async.parallel(
      {
        image(callback) {
          new Compressor(file, {
            quality: 0.6,
            convertSize: 100000,
            mimeType: "auto",
            success: (result) => {
              setImageUrl(URL.createObjectURL(result));
              uploadImage(result, (event) => {
                const percentComplete = Math.round((100 * event.loaded) / event.total);
              })
                .then((res) => {
                  setImageUrl(res.data.link);
                  callback(null, res.data.link);
                  imageChange("image", res.data.link);
                })
                .catch(() => {
                  callback("error image");
                })
                .finally(() => {});
            },
            error: (err) => {
              callback("error image");
            },
          });
        },
        thumbnail(callback) {
          new Compressor(file, {
            quality: 0.8,
            convertSize: 100000,
            maxWidth: 300,
            mimeType: "auto",
            success: (result) => {
              setThumbnailUrl(URL.createObjectURL(result));
              uploadImage(result, (event) => {
                const percentComplete = Math.round((100 * event.loaded) / event.total);
              })
                .then((res) => {
                  setThumbnailUrl(res.data.link);
                  callback(null, res.data.link);
                  imageChange("thumbnail", res.data.link);
                })
                .catch((e) => {
                  console.log(e);
                  callback("error thumbnail");
                })
                .finally(() => {});
            },
            error: (err) => {
              console.log(err);
              showError("Nén ảnh bị lỗi");
              callback("error thumbnail");
            },
          });
        },
      },
      (err, results) => {
        if (err) {
          console.log(err);
          toast.error("Không đăng tải được ảnh", TOASTIFY_OPTIONS);
          fileRemoveHandler();
          return;
        }
      },
    );
  };

  const fileRemoveHandler = () => {
    imageRef.current.value = "";
    setImageUrl("");
    setThumbnailUrl("");
    imageChange("thumbnail", "");
    imageChange("image", "");
  };

  return (
    <>
      <div
        className="d-flex flex-row align-items-center mb-3"
        style={{ opacity: blur ? "50%" : "100%" }}
        onClick={addClick}
      >
        <div
          role="button"
          className="d-flex align-items-center"
          aria-hidden="true"
          onClick={() => !blur && correctChange()}
        >
          {type === "single" && (
            <FontAwesomeIcon
              icon={is_correct ? faCircleCheck : faCircle}
              size="lg"
              style={{ color: is_correct ? "#1DCD0E" : "" }}
            />
          )}
          {type === "multiple" && (
            <FontAwesomeIcon
              icon={is_correct ? faSquareCheck : faSquare}
              size="lg"
              style={{ color: is_correct ? "#1DCD0E" : "" }}
            />
          )}
        </div>

        <Form.Control
          type="text"
          className="mx-2"
          name="content"
          placeholder="Tuỳ chọn"
          value={content}
          onChange={(e) => inputChange(e)}
          onKeyUp={(e) => e.key === "Tab" && addClick()}
          autoFocus={isLast}
          readOnly={blur}
          style={{ cursor: blur ? "pointer" : "auto" }}
        />

        <div
          role="button"
          className="d-flex align-items-center p-1 px-2 me-2"
          aria-hidden="true"
          onClick={() => imageRef.current.click()}
        >
          <i className="fa-light fa-image fa-lg" />
        </div>

        <div
          role="button"
          className="d-flex align-items-center p-1 px-2"
          aria-hidden="true"
          onClick={() => !blur && removeClick()}
        >
          <i className="fa-light fa-xmark fa-lg"></i>
        </div>

        <input
          ref={imageRef}
          type="file"
          accept="image/*"
          className="d-none"
          onChange={fileChangeHandler}
        />
      </div>

      {thumbnailUrl && (
        <div className="d-flex my-2 px-4 pb-4">
          <div className="preview-img rounded-10 position-relative">
            <img className="rounded-10" src={thumbnailUrl} width="300" />
            <div
              role="button"
              className="close btn btn-sm rounded position-absolute end-0 top-0 m-3"
              onClick={fileRemoveHandler}
            >
              <i className="fa-solid fa-xmark" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const CreateAnswer = observer(
  forwardRef(({ answersData, typeAnswer }, ref) => {
    const [inputList, setInputList] = useState([
      { content: "", image_url: null, thumbnail_url: null, is_correct: false },
    ]);

    useEffect(() => {
      if (answersData) {
        setInputList(answersData);
      } else {
        setInputList([{ content: "", image_url: null, thumbnail_url: null, is_correct: false }]);
      }
    }, [answersData]);

    useImperativeHandle(ref, () => ({
      getAnswers() {
        return inputList;
      },
    }));

    // handle input change
    const handleInputChange = (e, index) => {
      const { name, value } = e.target;
      const list = [...inputList];
      // list[index][name] = value;
      list[index] = {
        ...list[index],
        content: value,
      };
      setInputList(list);
    };

    // handle correct change
    const handleCorrectChange = (index) => {
      const list = [...inputList];
      if (typeAnswer === 'single') {
        for (let i = 0; i < list.length; i++) {
          list[i] = {
            ...list[i],
            is_correct: i === index ? true : false,
          };
        }
      } else {
        list[index] = {
          ...list[index],
          is_correct: list[index]["is_correct"] ? false : true,
        };
      }
      setInputList(list);
    };

    // handle image change
    const handleImageChange = (name, value, index) => {
      const list = [...inputList];
      if (name === "image") {
        list[index] = {
          ...list[index],
          image_url: value,
        };
      } else {
        list[index] = {
          ...list[index],
          thumbnail_url: value,
        };
      }
      setInputList(list);
    };

    // handle click event of the Remove button
    const handleRemoveClick = (index) => {
      const list = [...inputList];
      if (list.length > 1) {
        list.splice(index, 1);
        setInputList(list);
      }
    };

    // handle click event of the Add button
    const handleAddClick = () => {
      setInputList([...inputList, { content: "", image_url: null, thumbnail_url: null, is_correct: false }]);
    };

    return (
      <div className="mb-3">
        {inputList?.map((x, i) => (
          <AnswerBlock
            key={i}
            data={x}
            type={typeAnswer}
            isLast={i === inputList.length - 1}
            inputChange={(e) => handleInputChange(e, i)}
            removeClick={() => handleRemoveClick(i)}
            correctChange={() => handleCorrectChange(i)}
            imageChange={(name, value) => handleImageChange(name, value, i)}
          />
        ))}
        <AnswerBlock
          blur={true}
          type={typeAnswer}
          data={{ is_correct: false, content: "" }}
          addClick={() => handleAddClick()}
        />
      </div>
    );
  }),
);
